module.exports = {
	"title": "::selection CSS pseudo-element",
	"description": "The ::selection CSS pseudo-element applies rules to the portion of a document that has been highlighted (e.g., selected with the mouse or another pointing device) by the user.",
	"spec": "http://www.w3.org/TR/css-pseudo-4/#selectordef-selection",
	"status": "wd",
	"links": [
		{
			"url": "http://quirksmode.org/css/selectors/selection.html",
			"title": "::selection test"
		},
		{
			"url": "http://docs.webplatform.org/wiki/css/selectors/pseudo-elements/::selection",
			"title": "WebPlatform Docs"
		}
	],
	"bugs": [
		{
			"description": "In Safari `::selection` styles do not work in combination with CSS multi-column."
		}
	],
	"categories": [
		"CSS"
	],
	"stats": {
		"ie": {
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "y",
			"10": "y",
			"11": "y",
			"5.5": "n"
		},
		"edge": {
			"12": "y",
			"13": "y",
			"14": "y"
		},
		"firefox": {
			"2": "y x",
			"3": "y x",
			"4": "y x",
			"5": "y x",
			"6": "y x",
			"7": "y x",
			"8": "y x",
			"9": "y x",
			"10": "y x",
			"11": "y x",
			"12": "y x",
			"13": "y x",
			"14": "y x",
			"15": "y x",
			"16": "y x",
			"17": "y x",
			"18": "y x",
			"19": "y x",
			"20": "y x",
			"21": "y x",
			"22": "y x",
			"23": "y x",
			"24": "y x",
			"25": "y x",
			"26": "y x",
			"27": "y x",
			"28": "y x",
			"29": "y x",
			"30": "y x",
			"31": "y x",
			"32": "y x",
			"33": "y x",
			"34": "y x",
			"35": "y x",
			"36": "y x",
			"37": "y x",
			"38": "y x",
			"39": "y x",
			"40": "y x",
			"41": "y x",
			"42": "y x",
			"43": "y x",
			"44": "y x",
			"45": "y x",
			"46": "y x",
			"47": "y x",
			"48": "y x",
			"49": "y x",
			"50": "y x",
			"51": "y x",
			"52": "y x",
			"53": "y x",
			"3.5": "y x",
			"3.6": "y x"
		},
		"chrome": {
			"4": "y",
			"5": "y",
			"6": "y",
			"7": "y",
			"8": "y",
			"9": "y",
			"10": "y",
			"11": "y",
			"12": "y",
			"13": "y",
			"14": "y",
			"15": "y",
			"16": "y",
			"17": "y",
			"18": "y",
			"19": "y",
			"20": "y",
			"21": "y",
			"22": "y",
			"23": "y",
			"24": "y",
			"25": "y",
			"26": "y",
			"27": "y",
			"28": "y",
			"29": "y",
			"30": "y",
			"31": "y",
			"32": "y",
			"33": "y",
			"34": "y",
			"35": "y",
			"36": "y",
			"37": "y",
			"38": "y",
			"39": "y",
			"40": "y",
			"41": "y",
			"42": "y",
			"43": "y",
			"44": "y",
			"45": "y",
			"46": "y",
			"47": "y",
			"48": "y",
			"49": "y",
			"50": "y",
			"51": "y",
			"52": "y",
			"53": "y",
			"54": "y",
			"55": "y",
			"56": "y",
			"57": "y"
		},
		"safari": {
			"4": "y",
			"5": "y",
			"6": "y",
			"7": "y",
			"8": "y",
			"9": "y",
			"10": "y",
			"3.1": "y",
			"3.2": "y",
			"5.1": "y",
			"6.1": "y",
			"7.1": "y",
			"9.1": "y",
			"TP": "y"
		},
		"opera": {
			"9": "n",
			"11": "y",
			"12": "y",
			"15": "y",
			"16": "y",
			"17": "y",
			"18": "y",
			"19": "y",
			"20": "y",
			"21": "y",
			"22": "y",
			"23": "y",
			"24": "y",
			"25": "y",
			"26": "y",
			"27": "y",
			"28": "y",
			"29": "y",
			"30": "y",
			"31": "y",
			"32": "y",
			"33": "y",
			"34": "y",
			"35": "y",
			"36": "y",
			"37": "y",
			"38": "y",
			"39": "y",
			"40": "y",
			"41": "y",
			"42": "y",
			"43": "y",
			"9.5-9.6": "y",
			"10.0-10.1": "y",
			"10.5": "y",
			"10.6": "y",
			"11.1": "y",
			"11.5": "y",
			"11.6": "y",
			"12.1": "y"
		},
		"ios_saf": {
			"8": "n",
			"10": "n",
			"3.2": "n",
			"4.0-4.1": "n",
			"4.2-4.3": "n",
			"5.0-5.1": "n",
			"6.0-6.1": "n",
			"7.0-7.1": "n",
			"8.1-8.4": "n",
			"9.0-9.2": "n",
			"9.3": "n"
		},
		"op_mini": {
			"all": "n"
		},
		"android": {
			"3": "n",
			"4": "n",
			"53": "y",
			"2.1": "n",
			"2.2": "n",
			"2.3": "n",
			"4.1": "n",
			"4.2-4.3": "n",
			"4.4": "y",
			"4.4.3-4.4.4": "y"
		},
		"bb": {
			"7": "n",
			"10": "y"
		},
		"op_mob": {
			"10": "u",
			"11": "u",
			"12": "y",
			"37": "y",
			"11.1": "u",
			"11.5": "y",
			"12.1": "y"
		},
		"and_chr": {
			"53": "y"
		},
		"and_ff": {
			"49": "y x"
		},
		"ie_mob": {
			"10": "y",
			"11": "y"
		},
		"and_uc": {
			"11": "n"
		},
		"samsung": {
			"4": "y"
		}
	},
	"notes": "",
	"notes_by_num": {},
	"usage_perc_y": 74.39,
	"usage_perc_a": 0,
	"ucprefix": false,
	"parent": "",
	"keywords": "::selection,selection",
	"ie_id": "",
	"chrome_id": "",
	"firefox_id": "",
	"webkit_id": "",
	"shown": true
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/features-json/css-selection.json
 ** module id = 430
 ** module chunks = 0
 **/